import Svg, { SvgProps, Path } from 'react-native-svg'

export function CircleWarning(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        stroke={props.color ?? '#131214'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12 12.2V8.754m0 7.046h.008M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      />
    </Svg>
  )
}
